module.exports = __webpack_public_path__ + "assets/img/AnnouncementBAIOS.12d0c747.png";